import { useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { ArrowRecurringIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'
import { colorIconSecondary } from '@calendly/ui/theme'

import { useGetUserQuery } from 'common'

import { HoursAndDateOverrides } from './components'
import { HeaderWithIcon, PanelContentContainer, PanelContentHeader } from '../../styles'

export const ActiveAvailableHours = ({
  formPath,
  isLocked = false,
  isReadOnly = false
}) => {
  const { data: currentUser } = useGetUserQuery()
  const [{ value: { userUuid } }] = useFormField({ name: formPath })
  const isCurrentUserAvailability = currentUser.uuid === userUuid

  return (
    <PanelContentContainer>
      <PanelContentHeader>
        <HeaderWithIcon>
          <ArrowRecurringIcon color={colorIconSecondary} />
          <BodyText size="medium">
            {I18n.t('publisher.event_type_editor.sections.available_hours.weekly_hours')}
          </BodyText>
        </HeaderWithIcon>
        <BodyText size="small" color="muted">
          {isCurrentUserAvailability
            ? I18n.t('publisher.event_type_editor.sections.availability.weekly_hours_for_you')
            : I18n.t('publisher.event_type_editor.sections.availability.weekly_hours_for_host')}
        </BodyText>
      </PanelContentHeader>
      <HoursAndDateOverrides
        formPath={formPath}
        readOnly={isLocked || isReadOnly}
      />
    </PanelContentContainer>
  )
}
